import React from 'react';
import img from '../../../src/assets/live-chatbot.webp';


const Helpbot = () => {
    return (
        <>
            <div className="helpbot-section">
                <div className="container position-relative">
                    <div className="row">
                        <div className="col-12 text-center">
                            <div className='d-flex align-items-center justify-content-center'>
                                <div className="live-chatbot position-relative">
                                    <img src={img} alt="Live Chatbot" className="chat-img" loading="lazy" />
                                    <div className='arrow-set'>
                                        <span className="tap-text">Tap to Ask</span>
                                    </div>
                                </div>
                            </div>
                            <h4 className="still-head">Still Got Q’s?</h4>
                            <h6 className="helpboth6">Ask HelpBot Now!</h6>
                            <h5 className="helpboth5">Your Pool’s Best Friend—Right in Your Pocket!</h5>
                            <button className="btn btn-limit landing-slider-button">
                                Try free — Limited Spots
                            </button>
                        </div>
                    </div>

                </div>
            </div>
        </>
    );
}

export default Helpbot;